import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';
import { get, set } from '@totalsoft/react-state-lens';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { useTranslation } from 'react-i18next';
import { valueOrDefault } from 'utils/functions';
import { DateTime } from '@ts-private/rocket-extensions';
import LabeledCheckbox from 'components/common/inputs/LabeledCheckbox';

const LeasingIncomeSchemaGeneralDataComponent = ({ lens, validation, disabled }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          label={t('LeasingIncomeSchema.Code')}
          fullWidth
          required
          value={lens.code |> get |> valueOrDefault('')}
          onChange={lens.code |> set}
          error={!isValid(validation.code)}
          helperText={getErrors(validation.code)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label={t('LeasingIncomeSchema.Name')}
          fullWidth
          required
          value={lens.name |> get |> valueOrDefault('')}
          onChange={lens.name |> set}
          error={!isValid(validation.name)}
          helperText={getErrors(validation.name)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DateTime
          label={t('LeasingIncomeSchema.ValidFrom')}
          value={lens.validFrom |> get}
          onChange={lens.validFrom |> set}
          error={!isValid(validation.validFrom)}
          helperText={getErrors(validation.validFrom)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DateTime
          label={t('LeasingIncomeSchema.ValidTo')}
          value={lens.validTo |> get}
          onChange={lens.validTo |> set}
          error={!isValid(validation.validTo)}
          helperText={getErrors(validation.validTo)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <LabeledCheckbox label={t('LeasingIncomeSchema.IsActive')} checked={lens.isActive |> get |> valueOrDefault(false)} disabled />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          label={t('LeasingIncomeSchema.Notes')}
          value={lens.notes |> get}
          onChange={lens.notes |> set}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

LeasingIncomeSchemaGeneralDataComponent.propTypes = {
  lens: PropTypes.object,
  validation: PropTypes.object,
  disabled: PropTypes.bool
};

export default LeasingIncomeSchemaGeneralDataComponent;
